// Live search for custom-search.hbs (/plumb-the-depths/). Every
// published post and page is rendered server-side into JSON <script>
// islands (see that template -- Ghost's own {{#get}} data helper, no
// Content API key, no extra network request); this just filters that
// array as the visitor types and renders matching rows.
//
// Matching runs against full plaintext content, not just title/excerpt
// -- Ghost's auto-excerpt is only the first ~300 characters, so a
// phrase from partway through a long newsletter would never match
// otherwise. The excerpt shown per result is still the short one when
// it contains the match; when the match is only found further into
// the body, a short snippet is pulled from around it instead so the
// result makes sense at a glance.

function snippetAround(text, query, radius) {
    const idx = text.toLowerCase().indexOf(query);
    if (idx === -1) {
        return "";
    }
    const start = Math.max(0, idx - radius);
    const end = Math.min(text.length, idx + query.length + radius);
    const prefix = start > 0 ? "…" : "";
    const suffix = end < text.length ? "…" : "";
    return prefix + text.slice(start, end).trim() + suffix;
}

function readIndex(id) {
    const el = document.getElementById(id);
    if (!el) {
        return [];
    }
    try {
        return JSON.parse(el.textContent || "[]");
    } catch (err) {
        return [];
    }
}

function buildRow(item, displayExcerpt) {
    const row = document.createElement("a");
    row.className = "search-row";
    row.href = item.url;

    const cover = document.createElement("span");
    cover.className = "search-row-cover";
    if (item.feature_image) {
        const img = document.createElement("img");
        img.src = item.feature_image;
        img.alt = "";
        img.loading = "lazy";
        cover.appendChild(img);
    }
    row.appendChild(cover);

    const body = document.createElement("span");
    body.className = "search-row-body";

    const title = document.createElement("span");
    title.className = "search-row-title";
    title.textContent = item.title;
    body.appendChild(title);

    if (displayExcerpt) {
        const excerpt = document.createElement("span");
        excerpt.className = "search-row-excerpt";
        excerpt.textContent = displayExcerpt;
        body.appendChild(excerpt);
    }
    row.appendChild(body);

    const meta = document.createElement("span");
    meta.className = "search-row-meta";

    if (item.section) {
        const section = document.createElement("span");
        section.className = "search-row-section";
        section.textContent = item.section;
        meta.appendChild(section);
    }

    if (item.visibility && item.visibility !== "public") {
        const locked = document.createElement("span");
        locked.className = "search-row-locked";
        meta.appendChild(locked);
    }

    row.appendChild(meta);

    return row;
}

export default function search() {
    const input = document.getElementById("search-input");
    const results = document.getElementById("search-results");
    if (!input || !results) {
        return;
    }

    function prepare(item, section) {
        const haystack = [item.title, item.excerpt, item.plaintext, section]
            .filter(Boolean)
            .join(" \n ")
            .toLowerCase();
        return { ...item, section, haystack };
    }

    const posts = [...readIndex("search-index-posts-1"), ...readIndex("search-index-posts-2")].map(
        (p) => prepare(p, p.tags && p.tags[0] ? p.tags[0].name : null)
    );
    const pages = readIndex("search-index-pages").map((p) => prepare(p, "Page"));
    const all = [...posts, ...pages];

    function render(query) {
        const q = query.trim().toLowerCase();
        results.innerHTML = "";

        if (!q) {
            results.dataset.state = "empty";
            results.dataset.message = "start typing to search the archive.";
            return;
        }

        const matches = all.filter((item) => item.haystack.includes(q));

        if (!matches.length) {
            results.dataset.state = "none";
            results.dataset.message = "nothing down here.";
            return;
        }

        results.dataset.state = "results";
        matches.slice(0, 50).forEach((item) => {
            const excerptHasMatch = item.excerpt && item.excerpt.toLowerCase().includes(q);
            const displayExcerpt = excerptHasMatch
                ? item.excerpt
                : snippetAround(item.plaintext || "", q, 60) || item.excerpt;
            results.appendChild(buildRow(item, displayExcerpt));
        });
    }

    input.addEventListener("input", () => render(input.value));

    const params = new URLSearchParams(location.search);
    const initial = params.get("q");
    if (initial) {
        input.value = initial;
    }
    render(input.value);
}
